import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AboutInformation.css";
import { useNavigate } from "react-router-dom";

// Typewriter effect
import { Typewriter } from "react-simple-typewriter";

// Team Photos
import SurajPhoto from "../images/SURAJ.jpeg";
import PankajPhoto from "../images/pankaj.jpeg";
import AmitPhoto from "../images/Amit.jpg";

// PDF Profile Images
import Profile1 from "../images/Profile1.jpg";
import Profile2 from "../images/Profile2.jpg";
import Profile3 from "../images/Profile3.jpg";
import Profile4 from "../images/Profile4.jpg";
import Profile5 from "../images/Profile5.jpg";
import Profile6 from "../images/Profile6.jpg";
import Profile7 from "../images/Profile7.jpg";
import Profile8 from "../images/Profile8.jpg";
import Profile9 from "../images/Profile9.jpg";
import Profile10 from "../images/Profile10.jpg";
import Profile11 from "../images/Profile11.jpg";
import Profile12 from "../images/Profile12.jpg";
import Profile13 from "../images/Profile13.jpg";
import Profile14 from "../images/Profile14.jpg";
import Profile15 from "../images/Profile15.jpg";
import Profile16 from "../images/Profile16.jpg";
import Profile17 from "../images/Profile17.jpg";
import Profile18 from "../images/Profile18.jpg";
import Profile19 from "../images/Profile19.jpg";
import Profile20 from "../images/Profile20.jpg";
import Profile21 from "../images/Profile21.jpg";


function AboutInformation() {
  const navigate = useNavigate();
  const handleClick = () => navigate("/#home-our-services-section");

  useEffect(() => window.scrollTo({ top: 0, behavior: "smooth" }), []);

  // ===== PDF Slideshow Logic =====
  const profiles = [
    Profile1, Profile2, Profile3, Profile4, Profile5,
    Profile6, Profile7, Profile8, Profile9, Profile10,
    Profile11, Profile12, Profile13, Profile14, Profile15, 
    Profile16, Profile17, Profile18, Profile19, Profile20,
    Profile21
  ];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % profiles.length);
    }, 3000); // 3 sec per slide
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* About Us Header */}
      <div className="about-us-header text-center py-4">
        <h1 className="about-us-top">About Us</h1>
      </div>

      {/* About Section */}
      <section id="about" className="about-section">
        <div className="overlay"></div>
        <div className="container about-container">
          <div className="about-text-box">
            <h1 className="about-heading">Raysol Solar Tech Private Limited</h1>
            <p className="about-text text-dark">
              <Typewriter
                words={[
                  "At Raysol Solar Tech Private Limited, our mission is to make renewable energy accessible and affordable for everyone. We are dedicated to developing innovative solar solutions that not only save you money but also contribute to a healthier planet. We design solar systems that are efficient, reliable, and tailored to your needs, ensuring maximum savings and minimal hassle. Our expert team is committed to providing exceptional service and support, guiding you every step of the way. Join our growing family of customers who are embracing sustainable energy and making a positive impact on the environment. Experience seamless installation, cutting-edge technology, and long-term savings like never before. Take the first step towards a brighter, greener future with Raysol Solar Tech today!"
                ]}
                loop
                cursor
                cursorStyle="|"
                typeSpeed={5}
                deleteSpeed={0}
                delaySpeed={500}
              />
            </p>
            <div className="button-wrapper">
              <button className="about-explore-btn" onClick={handleClick}>
                Explore Services
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Text Carousel */}
      <div className="container text-center mt-5">
        <div id="aboutTextCarousel" className="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="4000">
          <div className="carousel-inner">
            {/* Slide 1 */}
            <div className="carousel-item active">
              <div className="about-card p-4">
                <p className="highlighted-text fade-text">
                  We are a leading solar energy provider dedicated to delivering clean, affordable, and reliable solar solutions.
                  <br />
                  Our team of experts helps you make the switch to solar and achieve energy independence.
                  <br />
                  Join us in creating a sustainable future with renewable energy solutions.
                </p>
              </div>
            </div>
            {/* Slide 2 */}
            <div className="carousel-item">
              <div className="about-card p-4">
                <h3 className="carousel-title">Vision and Mission</h3>
                <p className="highlighted-text fade-text">
                  Our Vision is to develop a team of young people committed to eco-friendly engineering.
                  <br />
                  We harness renewable energy for the betterment of tomorrow.
                  <br />
                  We provide affordable, reliable, and accessible power solutions.
                </p>
              </div>
            </div>
            {/* Slide 3 */}
            <div className="carousel-item">
              <div className="about-card p-4">
                <h3 className="carousel-title">Why Choose Us</h3>
                <p className="highlighted-text fade-text text-start px-4">
                  ✔ Expert Team: Highly qualified engineers design and implement projects.<br />
                  ✔ High Reliability: Trained in-house team assures prompt service.<br />
                  ✔ Tailored Solutions: Solutions tailored to your requirements.<br />
                  ✔ 150+ Completed Projects across industries.<br />
                  ✔ Quick Delivery with efficient execution.<br />
                  ✔ Quality Workmanship & best-in-class products.<br />
                  ✔ End-to-End Service: From procurement to after-sales.
                </p>
              </div>
            </div>
          </div>
          <div className="carousel-indicators mt-4">
            <button type="button" data-bs-target="#aboutTextCarousel" data-bs-slide-to="0" className="active"></button>
            <button type="button" data-bs-target="#aboutTextCarousel" data-bs-slide-to="1"></button>
            <button type="button" data-bs-target="#aboutTextCarousel" data-bs-slide-to="2"></button>
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#aboutTextCarousel" data-bs-slide="prev">
            <span className="carousel-control-prev-icon"></span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#aboutTextCarousel" data-bs-slide="next">
            <span className="carousel-control-next-icon"></span>
          </button>
        </div>
      </div>

      {/* Our Team Section */}
      <section id="team" className="team-section py-5">
        <div className="container">
          <h2 className="about-heading text-center mb-5">Our Team</h2>
          <div className="row">
            {/* Suraj */}
            <div className="col-md-4 mb-4">
              <div className="team-card shadow-lg p-4 text-center">
                <img src={SurajPhoto} alt="Mr. Suraj Vishwakarma" className="team-img mb-3" />
                <h4 className="fw-bold">Mr. Suraj Vishwakarma</h4>
                <p className="text-muted">PR.HEAD, Ex Adani Power</p>
                <p className="text-muted">B.Tech Electrical</p>
                <p className="text-muted">(9307345916)</p>
                <p className="fw-bold text-primary">Director</p>
              </div>
            </div>
            {/* Pankaj */}
            <div className="col-md-4 mb-4">
              <div className="team-card shadow-lg p-4 text-center">
                <img src={PankajPhoto} alt="Mr. Pankaj Pawar" className="team-img mb-3" />
                <h4 className="fw-bold">Mr. Pankaj Pawar</h4>
                <p className="text-muted">MA-ODCL, TISS Mumbai</p>
                <p className="text-muted">Dy. Engineer, Ex BHEL</p>
                <p className="text-muted">(9755393232)</p>
                <p className="fw-bold text-primary">Director</p>
              </div>
            </div>
            {/* Amit */}
            <div className="col-md-4 mb-4">
              <div className="team-card shadow-lg p-4 text-center">
                <img src={AmitPhoto} alt="Mr. Amit Sonar" className="team-img mb-3" />
                <h4 className="fw-bold">Mr. Amit Sonar</h4>
                <p className="text-muted">B.E Electrical Engineer</p>
                <p className="text-muted">Jalgaon</p>
                <p className="text-muted">(9307345916)</p>
                <p className="fw-bold text-primary">Director</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== PDF Profiles Slideshow Section ===== */}
      <section id="pdf-profiles" className="py-5 bg-light">
        <div className="container">
          <h2 className="about-heading text-center mb-5">Project Profiles</h2>
          <div className="slideshow-container">
            {profiles.map((profile, index) => (
              <img
                key={index}
                src={profile}
                alt={`Profile ${index + 1}`}
                className={currentIndex === index ? "active" : ""}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutInformation;
